import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

const RateIcon = () => (
    <svg width="43" height="42" viewBox="0 0 43 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_317_9897)">
            <path
                d="M21.9499 13.3398L17.4259 22.5798H21.5359L20.3959 28.9518L25.7479 19.6098H21.0559L21.9499 13.3398Z"
                stroke="white"
                strokeWidth="1.2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.7119 4.76572C20.3299 4.69372 20.9539 4.65771 21.5899 4.65771C30.7519 4.65771 38.1799 12.0857 38.1799 21.2477C38.1799 27.3737 34.8559 32.7257 29.9179 35.5997L29.9359 40.2917L23.0059 33.3497C29.0659 32.6477 33.7699 27.4937 33.7699 21.2477C33.7699 15.4637 29.7379 10.6217 24.3319 9.37371L19.7119 4.76572Z"
                stroke="white"
                strokeWidth="1.2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.202 6.932L13.214 2L20.342 9.128C14.198 9.752 9.404 14.942 9.404 21.248C9.404 27.164 13.622 32.096 19.214 33.2L23.744 37.7C23.036 37.79 22.322 37.838 21.59 37.838C12.428 37.838 5 30.41 5 21.248C5 15.146 8.294 9.818 13.202 6.932Z"
                stroke="white"
                strokeWidth="1.2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_317_9897">
                <rect width="42" height="42" fill="white" transform="translate(0.5)" />
            </clipPath>
        </defs>
    </svg>
);

const IP68Icon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none">
        <path d="M8.67994 15.604H7.49194V25.21H8.67994V15.604Z" fill="white" />
        <path
            d="M10.684 25.2099V15.6099H14.482C14.578 15.6099 14.686 15.6099 14.818 15.6159C14.944 15.6219 15.07 15.6399 15.19 15.6579C15.712 15.7359 16.15 15.9159 16.504 16.1919C16.858 16.4679 17.122 16.8159 17.302 17.2359C17.482 17.6559 17.572 18.1239 17.572 18.6339C17.572 19.1379 17.482 19.6059 17.302 20.0259C17.122 20.4459 16.852 20.7939 16.504 21.0699C16.15 21.3459 15.712 21.5259 15.202 21.6099C15.082 21.6279 14.956 21.6399 14.83 21.6519C14.704 21.6579 14.59 21.6639 14.494 21.6639H11.884V25.2099H10.684ZM11.866 20.5359H14.434C14.518 20.5359 14.614 20.5299 14.722 20.5239C14.83 20.5179 14.932 20.4999 15.034 20.4759C15.34 20.4039 15.592 20.2779 15.784 20.0859C15.976 19.8939 16.12 19.6719 16.204 19.4199C16.294 19.1679 16.336 18.9039 16.336 18.6339C16.336 18.3639 16.294 18.1059 16.204 17.8479C16.114 17.5959 15.976 17.3679 15.784 17.1819C15.592 16.9899 15.34 16.8579 15.034 16.7919C14.938 16.7679 14.83 16.7499 14.722 16.7439C14.614 16.7379 14.518 16.7319 14.434 16.7319H11.866V20.5359Z"
            fill="white"
        />
        <path
            d="M22.168 25.414C21.562 25.414 21.004 25.27 20.512 24.976C20.014 24.682 19.624 24.28 19.33 23.776C19.042 23.266 18.892 22.69 18.892 22.048V18.856C18.892 18.184 19.036 17.59 19.33 17.074C19.618 16.558 20.02 16.15 20.53 15.856C21.04 15.568 21.622 15.418 22.276 15.418C22.804 15.418 23.296 15.526 23.752 15.742C24.208 15.958 24.592 16.27 24.904 16.672L24.016 17.458C23.824 17.176 23.578 16.954 23.272 16.792C22.966 16.63 22.636 16.546 22.276 16.546C21.856 16.546 21.478 16.648 21.154 16.846C20.824 17.05 20.572 17.314 20.386 17.65C20.2 17.98 20.104 18.34 20.104 18.718V20.644L19.846 20.35C20.128 19.948 20.482 19.63 20.914 19.39C21.346 19.15 21.814 19.03 22.318 19.03C22.912 19.03 23.446 19.174 23.92 19.45C24.394 19.732 24.766 20.11 25.042 20.584C25.312 21.064 25.45 21.598 25.45 22.192C25.45 22.792 25.3 23.326 25 23.812C24.706 24.298 24.304 24.682 23.812 24.97C23.308 25.27 22.762 25.414 22.168 25.414ZM22.168 24.262C22.552 24.262 22.9 24.172 23.218 23.986C23.536 23.8 23.782 23.554 23.968 23.242C24.154 22.93 24.244 22.582 24.244 22.198C24.244 21.814 24.154 21.466 23.968 21.154C23.782 20.842 23.536 20.59 23.224 20.404C22.912 20.218 22.564 20.128 22.18 20.128C21.796 20.128 21.448 20.224 21.136 20.404C20.824 20.59 20.572 20.836 20.386 21.154C20.2 21.472 20.104 21.82 20.104 22.198C20.104 22.576 20.194 22.924 20.38 23.236C20.566 23.548 20.812 23.8 21.124 23.986C21.436 24.172 21.784 24.262 22.168 24.262Z"
            fill="white"
        />
        <path
            d="M30.1779 25.4139C29.5659 25.4139 29.0199 25.2879 28.5519 25.0419C28.0779 24.7959 27.7119 24.4539 27.4419 24.0099C27.1779 23.5719 27.0399 23.0559 27.0399 22.4679C27.0399 21.8919 27.1779 21.3759 27.4539 20.9139C27.7239 20.4519 28.1379 20.0979 28.6899 19.8459L28.6719 20.2779C28.2219 20.0619 27.8799 19.7499 27.6399 19.3539C27.3999 18.9579 27.2799 18.5139 27.2799 18.0279C27.2799 17.4879 27.4059 17.0199 27.6519 16.6239C27.8979 16.2339 28.2459 15.9279 28.6779 15.7179C29.1099 15.5079 29.6139 15.3999 30.1779 15.3999C30.7419 15.3999 31.2459 15.5079 31.6779 15.7179C32.1159 15.9279 32.4579 16.2339 32.7039 16.6239C32.9499 17.0139 33.0759 17.4819 33.0759 18.0279C33.0759 18.5139 32.9619 18.9519 32.7339 19.3479C32.5059 19.7379 32.1579 20.0499 31.6899 20.2779L31.6659 19.8519C32.2179 20.0919 32.6319 20.4459 32.9079 20.9079C33.1839 21.3699 33.3219 21.8919 33.3219 22.4679C33.3219 23.0559 33.1899 23.5659 32.9199 24.0099C32.6499 24.4479 32.2779 24.7959 31.8039 25.0419C31.3359 25.2879 30.7899 25.4139 30.1779 25.4139ZM30.1779 24.2799C30.7359 24.2799 31.1919 24.1239 31.5399 23.8179C31.8879 23.5119 32.0619 23.0619 32.0619 22.4739C32.0619 21.8799 31.8879 21.4299 31.5459 21.1239C31.1979 20.8119 30.7419 20.6619 30.1719 20.6619C29.6079 20.6619 29.1519 20.8179 28.8099 21.1239C28.4679 21.4359 28.2939 21.8859 28.2939 22.4739C28.2939 23.0619 28.4679 23.5119 28.8159 23.8179C29.1639 24.1239 29.6199 24.2799 30.1779 24.2799ZM30.1779 19.5159C30.6699 19.5159 31.0659 19.3899 31.3659 19.1439C31.6719 18.8979 31.8219 18.5259 31.8219 18.0339C31.8219 17.5419 31.6719 17.1699 31.3659 16.9239C31.0659 16.6779 30.6699 16.5519 30.1779 16.5519C29.6919 16.5519 29.2959 16.6779 28.9959 16.9239C28.6899 17.1699 28.5399 17.5419 28.5399 18.0339C28.5399 18.5259 28.6959 18.8979 28.9959 19.1439C29.3019 19.3899 29.6919 19.5159 30.1779 19.5159Z"
            fill="white"
        />
        <path
            d="M20.4099 39C30.6769 39 39 30.6769 39 20.4099C39 10.1429 30.6769 1.81982 20.4099 1.81982C10.1429 1.81982 1.81982 10.1429 1.81982 20.4099C1.81982 30.6769 10.1429 39 20.4099 39Z"
            stroke="white"
            strokeWidth="1.2"
            strokeMiterlimit="10"
        />
    </svg>
);

const FWIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="34" viewBox="0 0 37 34" fill="none">
        <path
            d="M1.21204 1.19385L14.364 6.73185V33.2758L1.21204 26.3818V1.19385Z"
            stroke="white"
            strokeWidth="1.2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.388 6.81585L24.798 1.19385V28.4758L14.364 33.2758L14.388 6.81585Z"
            stroke="white"
            strokeWidth="1.2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M24.7981 1.22412V28.4761L36.3481 33.2761V6.33012L24.7981 1.22412Z"
            stroke="white"
            strokeWidth="1.2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default function J_NA() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('outdoorrecreation');
    const icons: any = [
        {
            icon: <RateIcon />,
            text: t('secJ_tag1'),
        },
        {
            icon: <IP68Icon />,
            text: t('secJ_tag2'),
        },
        {
            icon: <FWIcon />,
            text: t('secJ_tag3'),
        },
    ];
    const img = {
        us: ['https://websiteoss.ecoflow.com/upload/image/1747388341228/9_na.jpg', 'https://websiteoss.ecoflow.com/upload/image/1747388345103/9_na_h5.jpg'],
        ca: ['https://websiteoss.ecoflow.com/upload/image/1747388341228/9_na.jpg', 'https://websiteoss.ecoflow.com/upload/image/1747388345103/9_na_h5.jpg'],
    };

    return (
        <div id="outdoor-recreation-J" className={`outdoor-recreation-J ${css['outdoor-recreation-J']}`}>
            <div className="img-box">
                <EFPicture src={img[locale][0]} srcMobile={img[locale][1]} alt={t('secJ_title')} />
                <div className="text-content">
                    <p className="title">{t('secJ_title')}</p>
                    <p className="desc">{t('secJ_desc')}</p>
                    <ul className="icons">
                        {icons?.map((icon: any) => (
                            <li className="icon-item" key={icon?.text}>
                                {icon?.icon}
                                <p className="icon-text">{icon?.text}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
